import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';

export function logModalError(logger, name) {
  return err => {
    if (err) {
      logger.error({err}, `modal ${name} closed with error.`);
    }

    return Observable.empty();
  };
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-modals/utils.js